import { LocalizedMessage, withLocalization } from '@client/internationalization';
import useTheme from '@material-ui/core/styles/useTheme';
import { Card } from '@minna-technologies/minna-ui/components/Card';
import { Caption } from '@minna-technologies/minna-ui/components/Typography/Caption';
import { UserIcon } from '@minna-technologies/minna-ui/icons/User';
import React from 'react';
import styles from '../styles.scss';
import { Body } from '@minna-technologies/minna-ui/components/Typography/Body';

export const UserCard = withLocalization('onboarding-psd2/Cards')(() => {
  const { colors } = useTheme();

  return (
    <Card className={styles.card} data-test={'card-one'}>
      <div className={styles['card-header']}>
        <div className={styles['icon-wrapper']}>
          <UserIcon />
        </div>
        <Body variant="bold">
          <LocalizedMessage id="personalDataCardHealine" />
        </Body>
      </div>
      <div className={styles['content-wrapper']}>
        <Caption style={{ color: colors.textOn.surfaceSubdued, margin: '8px 0 0' }}>
          <LocalizedMessage id="personalDataCardDescription" />
        </Caption>
      </div>
    </Card>
  );
});
